import React, { FC } from 'react';
import { Box, Container, Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import { Energy5Link } from 'components/energy5/atoms';
import useI18n from "evcharging/hooks/useI18n";

const useStyle = makeStyles((theme: Theme) => ({
  descriptionBlock: {
    backgroundColor: theme.palette.customColors.lightGray,
    padding: theme.spacing(10, 0),
    marginTop: theme.spacing(13),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(16, 0),
      marginTop: theme.spacing(20),
    },
  },
  text: {
    color: theme.palette.customColors.main,
    maxWidth: 641,
    margin: theme.spacing(0, 'auto'),
  },
  button: {
    margin: theme.spacing(0, 'auto'),
  },
}));

const QuestionsSectionFAQ: FC = () => {
  const { t } = useI18n();

  const classes = useStyle();

  return (
    <Box className={classes.descriptionBlock}>
      <Container maxWidth={false} fixed>
        <Grid container direction="row" justifyContent="center">
          <Grid item xs={12}>
            <Typography variant="h3" color="secondary" align="center">
              {t('faq.questions')}
            </Typography>
            <Box mt={2} mb={6}>
              <Typography variant="body1" align="center" className={classes.text}>
                {t('faq.questions.description')}
              </Typography>
            </Box>
            <Energy5Link href="/contact-us" text={t('nav.contact')} className={classes.button} />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default QuestionsSectionFAQ;
